import { PartsType, Platform, PreselectedDataType, ShopTheme } from "../types/types";
import { BASE_URL } from "../utils/constants";

export type LoaderDataType = {
  hasMonthlySubscription: boolean;
  showImagesInPartsFinder: boolean;
  onRequestCartMessage: string;
  forceBrand: string | undefined;
  shopAutoCreateProduct: boolean;
  shopShowExternalStock: boolean;
  preselectedData: PreselectedDataType;
  theme: ShopTheme;
  shopPlatform: Platform;
  loadedInitialData: any; // todo luci
};

const ACTION_DIAGRAM_SELECTED = "ACTION_DIAGRAM_SELECTED";
const ACTION_TYPE_SELECTED = "ACTION_TYPE_SELECTED";
const ACTION_MODEL_SELECTED = "ACTION_MODEL_SELECTED";

const API_URL_INITIAL_DATA = (permanentDomain: string, country: string, brand: string | undefined, locationHash: string | null) => {
  let url = `${BASE_URL}/api/partsfinder?permanentDomain=${permanentDomain}&country=${country}`;

  if (brand) {
    url += `&brand=${brand}`;
  }

  if (locationHash) {
    url += `&location=${locationHash}`;
  }

  return url;
};

export const fetchInitialPartsData = async (permanentDomain: string, country: string, forceBrand: string | undefined, locationHash: string | null) => {
  try {
    const response = await fetch(API_URL_INITIAL_DATA(permanentDomain, country, forceBrand, locationHash));
    const res: LoaderDataType = await response.json();

    return res;
  } catch (e) {
    return null;
  }
};

export const postTypeSelected = async (permanentDomain: string, country: string, brand: string, year: string, typeName: string) => {
  const url = `${BASE_URL}/api/partsfinder`;

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      type: ACTION_TYPE_SELECTED,
      brand,
      year,
      typeName,
      permanentDomain,
      country,
    }),
  });
  const json = await response.json();

  console.log("lucitest Type selected res", json);

  return json?.models;
};

type PostModelSelectedResponse = {
  diagrams: any;
  ownerManualLink: string | undefined;
};

export const postModelSelected = async (
  permanentDomain: string,
  country: string,
  brand: string,
  year: string,
  typeName: string,
  modelId: string
): Promise<PostModelSelectedResponse> => {
  const url = `${BASE_URL}/api/partsfinder`;

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      type: ACTION_MODEL_SELECTED,
      brand,
      year,
      typeName,
      modelId,
      permanentDomain,
      country,
    }),
  });
  const json = await response.json();

  console.log("lucitest postModelSelected", json);

  const diagrams = json?.diagrams;
  const ownerManualLink = json?.ownerManual?.url;
  return { diagrams, ownerManualLink };
};

export const postDiagramSelected = async (
  permanentDomain: string,
  country: string,
  brand: string,
  year: string,
  typeName: string,
  modelId: string,
  diagramId: string
) => {
  const url = `${BASE_URL}/api/partsfinder`;

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      type: ACTION_DIAGRAM_SELECTED,
      brand,
      year,
      typeName,
      modelId,
      diagramId,
      permanentDomain,
      country,
    }),
  });
  const json = await response.json();

  console.log("lucitest postDiagramSelected", json);

  return json?.parts;
};

export const postSendRequestQuote = async (name: string, email: string, phoneNumber: string, message: string, sku: string, shop: string) => {
  const url = `${BASE_URL}/api/request-quote`;

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      name,
      email,
      phoneNumber,
      message,
      sku,
      shop,
    }),
  });
  const json = await response.json();

  console.log("lucitest postSendRequestQuote", json);

  return json;
};

export type ExternalStockApiType = {
  sku: string;
  message: string;
  textColor: string;
  stock: number;
};

export const fetchExternalStock = async (sku: string, permanentDomain: string, country: string) => {
  const url = `${BASE_URL}/api/external-stock?sku=${sku}&permanentDomain=${permanentDomain}&country=${country}`;

  const response = await fetch(url, {
    method: "GET",
  });
  const json: ExternalStockApiType = await response.json();

  return json;
};

export const postAC = async (permanentDomain: string, part: PartsType | undefined) => {
  if (!part) {
    console.error("postAC: part is undefined");
    return;
  }

  const url = `${BASE_URL}/api/ac`;

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      permanentDomain,
      partSku: part!.id,
    }),
  });

  const json = await response.json();

  console.log("lucitest postAC", json);

  return json.realtimeData ? json.realtimeData : null;
};
